export default {
    inviteTop: "/gateway/huilianOperation/invitecs/inviteTop", //拉新奖励排名
    insertInvite: "/gateway/huilianOperation/invitecs/insertInvite", //拉新邀请-生成邀请码
};



// WEBPACK FOOTER //
// ./src/inviteNewUsers/index/api.js